// utils/formatarData.ts

/**
 * Converte Firestore Timestamp, Date, string ou número em data legível pt-BR.
 * Retorna 'Data inválida' se não conseguir converter.
 */
import { logger } from './logger';

export function formatarData(timestamp: any): string {
  try {
    // Firestore Timestamp
    if (timestamp && typeof timestamp.toDate === 'function') {
      return timestamp.toDate().toLocaleDateString('pt-BR');
    }
    // JS Date
    if (timestamp instanceof Date) {
      return timestamp.toLocaleDateString('pt-BR');
    }
    // String
    if (typeof timestamp === 'string') {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('pt-BR');
      }
    }
    // Número (milissegundos)
    if (typeof timestamp === 'number') {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('pt-BR');
      }
    }
    // Firestore Timestamp objeto
    if (timestamp && typeof timestamp === 'object' && 'seconds' in timestamp) {
      const date = new Date(timestamp.seconds * 1000);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('pt-BR');
      }
    }
    return 'Data inválida';
  } catch (error) {
    logger.warn('Error formatting date', { error });
    return 'Data inválida';
  }
}
